import React from 'react'
import { Link } from 'react-router-dom';
import { FlexContainer } from '../styles/globalStyle';
 const PendingVerification = () => {
     return ( 
         <FlexContainer style={{height: '80vh'}}>
             <img style={{alignSelf: 'center'}} width="400px" src='./searching.gif' />
             <h2 style={{alignSelf: 'center'}}>Your account has not been activated yet. As soon as possible it will be activated by our concern team.</h2>
            <h4 style={{alignSelf: 'center'}}>Email us <Link to="mailto:support@fakebuzz.net">support@fakebuzz.net</Link> </h4>
         
         
         </FlexContainer>
      );
 }
  
 export default PendingVerification;